import {
    logoBronzeContestPriceInCents,
    logoPlatinumContestPriceInCents,
    logoBrandIdentityPriceInCents,
    logoBrandIdentityPercentageSavings,
    logoBusinessCardPriceInCents,
    logoBusinessCardSavingsInCents,
    logoWebPriceInCents,
    logoWebSavingsInCents,
    maximumLogoPriceFromFaqsInCents,
} from './pricing';
import type { Currency } from '../../../../shared/lib/currency';

export type BundleOptionKey =
    | 'base-option'
    | 'logo-business-card-design'
    | 'logo-web-bundle'
    | 'brand-identity-pack';

type LogoOptionKey = BundleOptionKey | 'platinum-option' | 'max-logo-price-faqs';

export function getLogoSavingsFixedAmount(
    bundleOptionKey: LogoOptionKey,
    currency: Currency
): number {
    const bundleSavings: Record<string, number> = {
        'logo-business-card-design': logoBusinessCardSavingsInCents[currency],
        'logo-web-bundle': logoWebSavingsInCents['USD'],
    };

    return bundleSavings[bundleOptionKey];
}

export function getLogoSavingsPercentage(
    bundleOptionKey: LogoOptionKey,
    currency: Currency
): number {
    const bundleSavings: Record<string, number> = {
        'brand-identity-pack': logoBrandIdentityPercentageSavings[currency],
    };

    return bundleSavings[bundleOptionKey];
}

export function getLogoPrice(bundleOptionKey: LogoOptionKey, currency: Currency): number {
    const bundlePricing: Record<string, number> = {
        'base-option': logoBronzeContestPriceInCents[currency],
        'platinum-option': logoPlatinumContestPriceInCents[currency],
        'brand-identity-pack': logoBrandIdentityPriceInCents[currency],
        'logo-business-card-design': logoBusinessCardPriceInCents[currency],
        'logo-web-bundle': logoWebPriceInCents['USD'],
        'max-logo-price-faqs': maximumLogoPriceFromFaqsInCents[currency],
    };

    return bundlePricing[bundleOptionKey];
}

export const stringContainsPrice = (string: string): boolean => {
    return string.includes('{fromPrice}') || string.includes('{toPrice}');
};
